import type { JSX } from 'react';

import { Box, type SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { getErrorMessageComponentSx } from '@components/styles/sxProperties';

interface IErrorMessage {
  errorMessage: string;
  errorMessageSx?: SxProps<Theme>;
}

export const ErrorMessage = ({
  errorMessage,
  errorMessageSx = {},
}: IErrorMessage): null | JSX.Element =>
  errorMessage ? (
    <Box sx={getErrorMessageComponentSx({ errorMessageSx })}>
      {errorMessage}
    </Box>
  ) : null;
